import Vue       from 'vue';
import Router    from 'vue-router';
import Home      from '../views/Home.vue';
import Susan     from '@/components/Patients/patients/susan';
import Joseph    from '@/components/Patients/patients/joseph';
import Gabrielle from '@/components/Patients/patients/gabrielle';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'Home',
			component: Home,
			meta: {
				id: 0
			}
		}, {
			path: '/patients/susan/',
			name: 'Susan',
			component: Susan,
			pathToRegexpOptions: { strict: true },
			meta: {
				id: 1
			}
		}, {
			path: '/patients/joseph/',
			name: 'Joseph',
			component: Joseph,
			pathToRegexpOptions: { strict: true },
			meta: {
				id: 2
			}
		}, {
			path: '/patients/gabrielle/',
			name: 'Gabrielle',
			component: Gabrielle,
			pathToRegexpOptions: { strict: true },
			meta: {
				id: 3
			}
		}
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return {
				x: 0,
				y: 0
			};
		}
	}
});

router.beforeEach((to, from, next) => {
	if (to.name === 'home') {
		document.documentElement.classList.add('hidden-ovelflow-html');
	} else {
		document.documentElement.classList.remove('hidden-ovelflow-html');
	}
	next();
});

export default router;
